import { randNumber } from "@ngneat/falso";
import { DataFieldType } from "src/types/data-field.types";
import { arrayNodeDef } from "./array";
import { createNodeDef } from "../nodes.helpers";

export const randomLengthArrayNodeDef = createNodeDef({
  type: "randomLengthArray",
  displayName: "Array (random length)",
  shortDisplayName: "Array",
  description: "A list of random length with all child nodes",
  acceptsChildren: true,
  fields: [
    { type: DataFieldType.NUMBER, key: "min", label: "Min" },
    { type: DataFieldType.NUMBER, key: "max", label: "Max" },
  ],
  initialData: () => ({ min: 1, max: 5 }),
  generate: () => null,
  shadowingTree: (tree, treeNode) => {
    const { min, max } = treeNode.node.data;
    const length = randNumber({
      min: Math.max(0, Math.min(min, max)),
      max: Math.min(999_9999, Math.max(min, max)),
    });

    const arrayNode = arrayNodeDef.create(treeNode.node.name, { length });
    arrayNode.id = treeNode.node.id;

    const index = tree.nodes.indexOf(treeNode);
    const replacedNodes = tree.nodes.slice();
    replacedNodes[index] = { ...treeNode, node: arrayNode };

    return { ...tree, nodes: replacedNodes };
  },
});
